export default function RequiredStarLabel() {
  return <span style={{ color: 'red' }}>*</span>;
}
